import React, { useCallback, useState } from 'react';
import { Editor } from 'slate';

import Notification, { notify } from '@ui/Notification';

import classes from './style.module.scss';

export const docSizeWarning = () => (
  <Notification className={classes['DashEditor-Notify']} dismissible>
    <span>
      We recommend keeping individual pages below 400 lines. Use smaller pages for an&nbsp;
      <a href="https://docs.readme.com/main/docs/editor-best-practices" rel="noreferrer" target="_blank">
        optimal editing experience
      </a>
      , or continue at your own risk.
    </span>
  </Notification>
);

const CHILDREN_LENGTH_SOFT_LIMIT = 400;

const useLargeDocWarning = () => {
  const [firstWarning, setFirstWarning] = useState(true);

  const checkLargeDoc = useCallback(
    editor => {
      if (!Editor.isEditor(editor)) return;

      if (editor.children.length > CHILDREN_LENGTH_SOFT_LIMIT && firstWarning) {
        setFirstWarning(false);
        window.requestAnimationFrame(() => {
          notify(docSizeWarning);
        });
      } else if (editor.children.length <= CHILDREN_LENGTH_SOFT_LIMIT && !firstWarning) {
        // Notify again when page lines is over the limit again
        setFirstWarning(true);
      }
    },
    [firstWarning],
  );

  return { checkLargeDoc };
};
export default useLargeDocWarning;
